import { render, staticRenderFns } from "./liquidar.vue?vue&type=template&id=6cf92ca9&scoped=true"
import script from "./liquidar.vue?vue&type=script&lang=js"
export * from "./liquidar.vue?vue&type=script&lang=js"
import style0 from "./liquidar.vue?vue&type=style&index=0&id=6cf92ca9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf92ca9",
  null
  
)

export default component.exports